import { FC, useEffect } from 'react';
import Page, { PageProps } from '@/components/page';
import RouterTabs from '@/components/router-tabs';
import { useQuery } from 'react-query';
import { useParams } from '@tanstack/react-router';
import useApp from '@/hooks/use-app.hook';
import { QueryKey } from '@/lib/query-client';
import { getAgentById } from '@/lib/services/agent.service';
import AgentAdminProfileForm from './admin-profile-form';
import SystemPromptForm from './system-prompt';
import DatasourcesForm from './datasources-form';
import AgentPortalForm from './portal-form';

const AgentViewPage: FC<PageProps> = () => {
  const { agentId } = useParams({ from: '/config/assistants/$agentId' });
  const { setPageTitle } = useApp();

  const { data: agent } = useQuery([QueryKey.AgentView, agentId], async () =>
    getAgentById(agentId)
  );

  useEffect(() => {
    if (agent) {
      setPageTitle(agent.name, 'agent');
    }
  }, [agent, setPageTitle]);

  return (
    <Page>
      <RouterTabs
        panels={[
          {
            label: 'Profile',
            path: 'profile',
            component: <AgentAdminProfileForm agentId={agentId} />,
          },
          { label: 'Branding', path: 'branding', component: <AgentPortalForm agentId={agentId} /> },
          {
            label: 'Model and Prompt',
            path: 'model-and-prompt',
            component: <SystemPromptForm agentId={agentId} />,
          },
          {
            label: 'Data Sources',
            path: 'data-sources',
            component: <DatasourcesForm agentId={agentId} />,
          },
        ]}
      />
    </Page>
  );
};

export default AgentViewPage;
